import { addHocItem } from "@/api/adhoc-items";
import { addBonusItem } from "@/api/bonus-items";
import Dropdown, { Item } from "@/components/form/Dropdown";
import NumberInput from "@/components/form/NumberInput";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";

import {
  BonusItem,
  BonusItemType,
  BonusItemTypeLabels,
} from "@/models/bonus-items.model";
import React, { useState } from "react";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
  updateBonusItems: (item: BonusItem) => void;
}

export const bonusItemTypeArray: Item[] = Object.values(BonusItemType).map(
  (value) => ({
    value: value,
    label: BonusItemTypeLabels[value],
  })
);

function AddBonusForm({
  userId,
  month,
  year,
  payslipId,
  updateBonusItems,
}: Props) {
  const [type, setType] = useState<string>("");
  const [amount, setAmount] = useState<number>(0);
  const [err, setErr] = useState<string>("");
  const isValid = () => {
    if (type === "" || amount === 0) {
      setErr("Please fill all fields.");
      return false;
    }
    if (amount <= 0) {
      setErr("Amount must be greater than 0.");
      return false;
    }
    setErr("");
    return true;
  };

  const handleBonusItem = async () => {
    if (!isValid()) {
      return;
    }
    try {
      const bonusItem = await addBonusItem({
        amount,
        type: type as BonusItemType,
        userId,
        month,
        year,
        payslipId,
      });
      updateBonusItems(bonusItem);
      if (bonusItem) {
        toast({
          title: "Bonus item added",
          description: `Bonus item ${
            BonusItemTypeLabels[type as BonusItemType]
          } added successfully`,
        });
        setErr("");
        setType("");
        setAmount(0);
      }
    } catch (err) {
      console.error(err);
      toast({
        title: "Error",
        description: "Failed to add bonus item",
        variant: "destructive",
      });
    }
  };
  return (
    <div className="flex gap-2 flex-col mt-3">
      <div className="flex gap-2 items-end">
        <Dropdown
          label="Type"
          items={bonusItemTypeArray}
          selectedString={type}
          setSelectedString={setType}
        />
        <NumberInput
          label="Amount"
          value={amount}
          setValue={setAmount}
          placeholder="Amount"
        />
        <Button onClick={handleBonusItem}>Add</Button>
      </div>
      {err && <div className="text-red-500 text-sm">{err}</div>}
    </div>
  );
}

export default AddBonusForm;
